import React from 'react';
import { CustomMuiThemeProvider } from 'theme/CustomMuiThemeProvider';
import DispatchMonitorView from './DispatchMonitorView';

const DispatchMonitor: React.FC = () => (
  <CustomMuiThemeProvider>
    <DispatchMonitorView />
  </CustomMuiThemeProvider>
);

export default DispatchMonitor;
